import {Modal} from 'react-bootstrap'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import useApi from '../../../../../../hooks/useQuery'
import {
  GET_LAB_ROOM_LIST,
  GET_SCAN_AVAILABILITY_ON_DATE,
  REVERSE_SCAN_APPOINTMENT_TIMESLOT,
} from '../../../GraphQLQueries/ProductOffering'
import {useEffect, useState} from 'react'
import DatePicker from 'react-datepicker'
import useLazyQueryApi from '../../../../../../hooks/useLazyQuery'
import moment from 'moment'
import './appointment.css'
import useMutationApi from '../../../../../../hooks/useMutation'

const TimeSlotModal = (props: any) => {

  
  console.log('props in timeslot modal :', props)
  const {loading, error, data} = useApi('', GET_LAB_ROOM_LIST, {})
  const [labRooms, setLabRooms] = useState<any[]>([])
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date())
  const [slots, setSlots] = useState<any[] | null>(null)
  const [selectedRoom, setSelectedRoom] = useState<any>()
  const [selectedSlot, setSelectedSlot] = useState<any>(null)


  console.log('selectedDate', selectedDate)


  const filterOption = [
    {
      id: 1,
      value: 'AvailableSlots',
      title: 'Show Available only',
    },
    {
      id: 2,
      value: 'AllSlots',
      title: 'Show All Time Slots',
    },
  ]

  console.log('SelectedRoom', selectedRoom)

  const [selectedFilter, setSelectedFilter] = useState(filterOption[0].value)

  const {
    fetchData: fetchSlots,
    loading: slotsLoading,
    data: slotsData,
  } = useLazyQueryApi('', GET_SCAN_AVAILABILITY_ON_DATE)

  const {
    createData,
    loading: reverseLoading,
    error: reverseError,
    data: reverseData,
  } = useMutationApi(REVERSE_SCAN_APPOINTMENT_TIMESLOT)

  const disableTimings2 = (time: any, array: any) => {
    const disabledArray = array.map((item: any) => {
      const {slotStart} = item
      var date = moment(item?.slotStart).format('DD-MM-YYYY')
      var date1 = moment(time).format('DD-MM-YYYY')

      if (date === date1) {
        let time2 = new Date(slotStart).getTime()
        let time3 = time.getTime()
        let disabled = moment(time2).isSameOrBefore(time3)
        return {...item, disabled}
      } else {
        return {...item, disabled: false}
      }
    })
    return disabledArray
  }

  useEffect(() => {
    const fetchData = async () => {

      if (selectedRoom && selectedDate) {
        let availableInput: any = {}
        availableInput.date = moment(selectedDate).format('YYYY-MM-DD')
        availableInput.slotFilter = selectedFilter
        availableInput.labRoomId = selectedRoom.id
        availableInput.businessProfileId = ''
        console.log(availableInput, 'check')

        await fetchSlots(availableInput)
      }
    }
    // setSlots(null)
    setSelectedSlot(null)

    fetchData()
  }, [selectedRoom, selectedDate, selectedFilter])

  useEffect(() => {
    if (data) {
      console.log(data)
      const avaliableRoom = data.getAllLabRooms.filter(
        (room: any) => room.roomType === props.product.productValue
      )
      setSelectedRoom(avaliableRoom[0])
      setLabRooms(avaliableRoom)
    }
  }, [data])

  useEffect(() => {
    const slotdata = async () => {
      if (slotsData) {
        let data1 = await slotsData?.getScanAvailabilityOnDate
        let data2 = await disableTimings2(new Date(), data1)
        setSlots(data2)
        console.log('data2', data2)
      }
    }
    slotdata()
  }, [slotsData])

  console.log('slotsData', reverseData?.reserveScanAppointmentTimeSlot.reverseData, reverseData)

  const handleTempTimeSlot = async () => {
    const tempAppointmentInput = {
      patientId: props.patientInfo.patientId,
      patientRoleId: props.patientInfo.patientRoleId,
      doctorId: props.patientInfo.doctorId || null,
      doctorRoleId: props.patientInfo.doctorRoleId || null,
      labRoomId: selectedRoom?.id,
      testProductId: props.product.productId,
      appointmentStartTime: selectedSlot?.slotStart,
      appointmentEndTime: selectedSlot?.slotEnd,
      // businessProfileId: '',
    }

    try {
    const response=  await createData({
        appointmentInput: tempAppointmentInput,
      })
      console.log('Temp appointment response :', response)
return response;
      
    } catch (e) {
      console.log('Error in creating temp appointment :', e)
    }
  }

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <Modal
        show={true}
        dialogClassName='ePulse-modal ePulse-modal-50w'
        onHide={() => {
          props.closeModal()
        }}
        backdrop='static'
      >
        <Modal.Header className='border-0' closeButton>
          <span className='fs-3 fw-bold'>TimeSlot</span>
        </Modal.Header>
        <Modal.Body className='container'>
          <div className='mb-3 d-flex justify-content-between'>
            <div>
              <label className='form-label fw-bold'>Lab Rooms</label>
              <select
                className='form-select'
                value={selectedRoom?.roomName || null}
                onChange={(e) => {
                  const roomId = e.target.value
                  console.log('roomId', roomId)
                  const roomObj = labRooms.find((room: any) => room.roomName === roomId)
                  setSelectedRoom(roomObj)
                  console.log('roomObj', roomObj)
                }}
              >
                <option value=''>Select Lab Room</option>
                {labRooms.map((room: any) => (
                  <option key={room.id} value={room.roomName}>
                    {room.roomName}
                  </option>
                ))}
              </select>
            </div>

            <div className='col-md-6'>
              <label className='form-label fw-bold'>Select Date</label>

              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date as Date)}
                minDate={new Date()}
                className='form-control'
                dateFormat='dd/MM/yyyy'
              />
            </div>
          </div>
          <div className='mb-3'>
            {slots && (
              <div className='mb-3 '>
                <div className='d-flex align-items-center justify-content-between gap-3 mb-'>
                  <label className='form-label fw-bold'>Select Time Slot</label>
                  <div className='mb-2' style={{maxWidth: 220}}>
                    <select
                      className='form-select'
                      value={selectedFilter}
                      onChange={(e) => setSelectedFilter(e.target.value)}
                    >
                      {filterOption.map((opt) => (
                        <option key={opt.id} value={opt.value}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {slotsLoading ? (
                  <div>Loading slots...</div>
                ) : slots.length === 0 ? (
                  <div>No slots available</div>
                ) : (
                  <div className='d-flex flex-wrap gap-2 slot-scroll-container'>
                    {slots
                      .filter((slot) => !slot.disabled)
                      .map((slot, idx) => (
                        <div
                          key={slot.slotStart || idx}
                          className={`slot-item border rounded px-3 py-2 ${
                            slot.disabled ? 'bg-secondary text-white' : ''
                          } ${
                            selectedSlot && selectedSlot.slotStart === slot.slotStart
                              ? 'selected'
                              : ''
                          }`}
                          style={{
                            minWidth: 80,
                            textAlign: 'center',
                            opacity: slot.disabled ? 0.5 : 1,
                          }}
                          onClick={() => !slot.disabled && setSelectedSlot(slot)}
                        >
                          {moment(slot?.slotStart).format('hh:mm A')}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
            {selectedSlot && (
              <div className='d-flex justify-content-end align-items-center gap-3 mt-4'>
                <button
                  className='ePulse-btn-primary'
                  onClick={async () => {
                    props.closeModal()
                   const response= await handleTempTimeSlot()
                   console.log('Response from temp time slot :', response.data.reserveScanAppointmentTimeSlot.holdDuration)
                  //  console.log('Response from temp time slot :', response.reserveScanAppointmentTimeSlot.holdDuration)
                    props.onContinue({
                      slot: selectedSlot.slotStart,
                      appointmentStartTime: selectedSlot?.slotStart,
                      appointmentEndTime: selectedSlot?.slotEnd,
                      labRoomName: selectedRoom?.roomName,
                      labRoomId: selectedRoom?.id,
                      holdTimeSlot: response?.data.reserveScanAppointmentTimeSlot.holdDuration,
                    })
                  }}
                >
                  Continue
                </button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default TimeSlotModal
